export default __webpack_public_path__ + "static/media/Terminator's Diremaul.101f94e6.jpg";